module.exports = __webpack_public_path__ + "ae8d1d45e1bb0e0531ee1a930ebcac50.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/tea-cups.png
// module id = 2135
// module chunks = 0